<form name="Accountform" (ngSubmit)="f.form.valid && accountsubmit()" #f="ngForm" novalidate>
   <div id="top" class="wrapper   {{formClass}}">
      <!-- <div class="modal-header">
        
      </div> -->
      <div class="modal-body">
         <h2 class="sub-header-text">Account Creation</h2>
         <div *ngIf="error" class="errorclass">
            <p class="m-0" [innerHTML]="error"></p>
         </div>
         <div class="form-group">
            <div class="row">
               <div class="col-12 col-sm-6 col-lg-6">
                  <input type="text" id="fname" class="form-control" name="first_name" placeholder="First name"
                     [(ngModel)]="_parent.model.first_name" appForbiddenName="test" required>
               </div>
               <div class="col-12 col-sm-6 col-lg-6">
                  <input type="text" id="lname" class="form-control" placeholder="Last name" name="last_name"
                     [(ngModel)]="_parent.model.last_name" appForbiddenName="test" required>
               </div>
            </div>
         </div>
         <div class="form-group">
            <div class="row">
               <div class="col-12 col-sm-6 col-lg-6" id="rankPaygrade">
                  <select id="rankid" class="sel-opt form-control" name="military_rank" (change)="selectMilitaryRank()"
                     [(ngModel)]="_parent.model.military_rank">
                     <option value="" disabled>Paygrade</option>
                     <option *ngFor='let ranks of ranks' [value]="ranks.id">{{ ranks.name }}</option>
                  </select>
               </div>
               <div class="col-12 col-sm-6 {{zipclass}}">
                  <input type="number"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  class="form-control" id="zip" placeholder="Zip Code" name="zip_code" maxlength="5"
                  [(ngModel)]="_parent.model.zip_code" required>
               </div>
               <!--<div class="col-12 col-sm-6 col-lg-6">
                  <input type="text" class="form-control" placeholder="MOS/AFSC/Rating" name="MOS/AFSC/Rating"
                     [(ngModel)]="_parent.model.mos" id="mosid" (change)="clickMosData()">
               </div>-->
            </div>
         </div>
         <div class="form-group">
            <select id="rankid" class="sel-opt form-control" name="state_of_residence"
               [(ngModel)]="_parent.model.state_of_residence" required>
               <option value="" disabled>State Of Residence</option>
               <option *ngFor='let ss of states' [value]="ss.value">{{ ss.name }}</option>
            </select>
         </div>
         <div class="form-group">
            <input type="number"
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            class="form-control" id="phone_number" placeholder="Phone (optional)" name="phone" maxlength="10"
            [(ngModel)]="_parent.model.phone_number">
            <!--<div *ngIf="phone.touched && phone.errors.maxlength">
               <span class="text-danger">Enter a valid phone number</span>
            </div>
            <span class="small">NOTE: Please fill out if you wish to be contacted immediately. This is NOT a required field.</span>-->
         </div>
         <div class="form-group">
            <input type="email" class="form-control" id="email" placeholder="Email" name="email"
               [(ngModel)]="_parent.model.email"
               pattern="[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?"
               appForbiddenName="test" email>
         </div>
         <div class="form-group">
            <input type="password" class="form-control" id="password" placeholder="Password" minlength="6"
               name="password" [(ngModel)]="_parent.model.password" required #password="ngModel">
            <!--<div class="col-12 col-sm-6 col-lg-6">
               <input type="password" class="form-control" id="confirmpassword" placeholder="Confirm Password"
                  name="cpassword" [(ngModel)]="_parent.model.cpassword" required validateEqual="password"
                  #cpassword="ngModel">
            </div>-->
         </div>
         <!-- <div class="form-group">
          <input type="checkbox" class="faChkSqr">
          <label class="terms" for="">&nbsp;I agree with the <span class="terms-text">Terms & Policy</span></label>
          </div> -->
          <div class="form-group ">
            <label class="check-box">
               <input name="check_phone_number" type="checkbox" [(ngModel)]="_parent.model.check_phone_number">
               <span class="checked1"></span>
               <p class="terms" for="">&nbsp; <span class="small">By submitting this form, I agree with the CollegeRecon <a target="_blank"
                  href="https://app.collegerecon.com/privacy">privacy policy</a>, and that schools I request information from may contact me by email, phone calls, and SMS/Text Messages; including automated technology or pre-recorded voice messages. Message & data rates may apply. I understand that my consent is not a condition of purchasing services from the school.</span></p>
            </label>
         </div>
         <!-- <div class="form-group ">
            <label class="check-box">
               <input name="term" type="checkbox" [(ngModel)]="_parent.model.term" required>
               <span class="checked1"></span>
               <p class="terms" for="">&nbsp;I agree with the <span class="terms-text"><a target="_blank"
                        href="https://app.collegerecon.com/privacy">Privacy Policy</a></span></p> -->
            <!-- </label> -->
            <!--<p class="mb-0">
               <small>
                  We respect your privacy and will not provide your contact info to any schools.
               </small>
            </p>-->
         <!-- </div>  -->
       
         <div class="error-display" *ngIf="errdisplay">
            <ul class="p-0">
               <li *ngFor='let msg of errormsg' class="errorclass">{{ msg }}</li>
            </ul>
         </div>
      </div>
      <div class="modal-footer m-footer flex-column">
         <div class="d-flex justify-content-between w-100">
            <a href="javascript:void(0)" (click)="prevAction()" class="btn  btn-prev btn-xs">
               <i class="fas fa-arrow-left"></i> &nbsp; Prev
            </a>
            <div class="slider-scroll">
               <ul>
                  <li class="d-inline"><i class="far fa-circle"></i></li>
                  <li class="d-inline"><i class="far fa-circle"></i></li>
                  <li class="d-inline"><i class="far fa-circle"></i></li>
                  <li class="d-inline"><i class="far fa-circle"></i></li>
                  <li class="d-inline"><i class="fas fa-circle"></i></li>
               </ul>
            </div>
            <a href="javascript:void(0)" (click)="clickSubmit(f.form.valid)" [class.disabled]="isLoader"
               class="btn btn-next btn-xs">
               Submit &nbsp;<i *ngIf="!isLoader" class="fas fa-paper-plane"></i> <i *ngIf="isLoader"
                  class="fas fa-circle-notch fa-spin"></i>
            </a>
         </div>
         <div id="footer" class="text-center mt-3">
            <p>© {{ _parent.year }} CollegeRecon. All rights reserved.</p>
         </div>
      </div>
   </div>
</form>


// WEBPACK FOOTER //
// ./src/app/components/pworkflow/account/account.component.html